<ng-container [formGroup]="controlForm">
  <mat-label class="margin__b15" style="display: flex; margin-bottom: 15px">
    <mat-icon matSuffix>{{control.options.icon}}</mat-icon>
    {{ control.options.displayName}}
  </mat-label>
  <div>
    <mat-form-field appearance="outline" fxFlex="calc(30% - 25px)">
      <mat-label>Libellé </mat-label>
      <input formControlName="label"
             matInput
             matTooltip="le libellé qui sera affiché sur le formulaire à remplir"
             placeholder="Libellé du champ, par exemple Nom"
             type="text"
             required>
    </mat-form-field>
    <app-control-actions
      (controlActions)="optionsActions($event, control, indexControl)"></app-control-actions>
  </div>
  <div [hidden]="control.isInBlockAdmin || hideRequieredButton">
    <mat-slide-toggle formControlName="isRequired"
                      color="primary"
                      matTooltip="cliquer pour que le champ soit obligatoire ou optionnel à la saisie"
    >{{controlForm?.get('isRequired')?.value ? 'Obligatoire' : 'Optionnel'}}
    </mat-slide-toggle>
  </div>
</ng-container>
